import { BrowserRouter, Route, Switch, Redirect, withRouter } from "react-router-dom";
import NativeBackButton from "./helpers/NativeBackButton";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import App from "./components/App";
import Loadable from "react-loadable";
import Loading from "./components/helpers/loading";
import React from "react";
import ReactDOM from "react-dom/client";
import Root from "./Root";
import withTracker from "./withTracker";
import { Capacitor } from "@capacitor/core";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import CouponList from "./components/Mobile/Cart/Coupon/CouponList/CouponList";
import "./components/PageTransitions.css";
// import RedirectHandler from "./redirect-handler";
import ThemeColorController from "./components/ThemeColorController";
import {
  settleEnteredWrapper,
  releaseDocumentScrollLock,
} from "./helpers/pageTransitionScroll";
import { PersistentFooterContext } from "./components/Mobile/Footer/persistentFooterContext";
import PersistentAppNav from "./components/Shared/PersistentAppNav";
import { relayGooglePopupResultIfNeeded } from "./helpers/socialAuth";

// Suppress harmless dev-overlay noise (ResizeObserver quirk, cross-origin Google Maps scripts)
const suppressDevOverlayNoise = (e) => {
  if (!e || !e.message) {
    return;
  }
  const isResizeObserverLoop = e.message.includes("ResizeObserver loop");
  const isCrossOriginScriptError =
    e.message === "Script error." &&
    (!e.filename || e.filename === "" || String(e.filename).includes("google"));
  if (!isResizeObserverLoop && !isCrossOriginScriptError) {
    return;
  }
  const overlayDiv = document.getElementById("webpack-dev-server-client-overlay-div");
  const overlayContainer = document.getElementById("webpack-dev-server-client-overlay");
  if (overlayDiv) overlayDiv.style.display = "none";
  if (overlayContainer) overlayContainer.style.display = "none";
  e.stopImmediatePropagation();
};
window.addEventListener("error", suppressDevOverlayNoise);
window.addEventListener("error", suppressDevOverlayNoise, true);

// import NotFound from "./components/NotFound";
const NotFound = Loadable({
  loader: () => import("./components/NotFound"),
  loading: () => <Loading />,
});

// import Location from "./components/Mobile/Location";
const Location = Loadable({
  loader: () => import("./components/Mobile/Location"),
  loading: () => <Loading />,
});

// Login UI lives in FirstScreen (route /login); legacy Auth/Login component unused.

// import Register from "./components/Mobile/Auth/Register";
const Register = Loadable({
  loader: () => import("./components/Mobile/Auth/Register"),
  loading: () => <Loading />,
});

// import CartPage from "./components/Mobile/Cart";
const CartPage = Loadable({
  loader: () => import("./components/Mobile/Cart"),
  loading: () => null,
});

// import Account from "./components/Mobile/Account";
const Account = Loadable({
  loader: () => import("./components/Mobile/Account"),
  loading: () => <Loading />,
});

const EditProfilePage = Loadable({
  loader: () => import("./components/Mobile/Account/EditProfilePage"),
  loading: () => <Loading />,
});

const CustomerSupportPage = Loadable({
  loader: () => import("./components/Mobile/Account/CustomerSupportPage"),
  loading: () => <Loading />,
});

// Explore component removed - using Phase2Explore for both Sprint and Relay modes
// const Explore = Loadable({
//   loader: () => import("./components/Mobile/Explore"),
//   loading: () => <Loading />,
// });

// import ContentScreen from "./components/Mobile/ContentScreen";
const ContentScreen = Loadable({
  loader: () => import("./components/Mobile/ContentScreen"),
  loading: () => <Loading />,
});

// import Addresses from "./components/Mobile/Account/Addresses";
const Addresses = Loadable({
  loader: () => import("./components/Mobile/Account/Addresses"),
  loading: () => <Loading />,
});

// import Checkout from "./components/Mobile/Checkout";
const Checkout = Loadable({
  loader: () => import("./components/Mobile/Checkout"),
  loading: () => <Loading />,
});

// import RunningOrder from "./components/Mobile/RunningOrder";
const RunningOrder = Loadable({
  loader: () => import("./components/Mobile/RunningOrder"),
  loading: () => <Loading />,
});

// import Orders from "./components/Mobile/Account/Orders";
const Orders = Loadable({
  loader: () => import("./components/Mobile/Account/Orders"),
  loading: () => <Loading />,
});

// import WalletPage from "./components/Mobile/Account/Wallet";
const WalletPage = Loadable({
  loader: () => import("./components/Mobile/Account/Wallet"),
  loading: () => <Loading />,
});

// import BestSellingItems from "./components/Mobile/BestSellingItems";
const BestSellingItems = Loadable({
  loader: () => import("./components/Mobile/BestSellingItems"),
  loading: () => <Loading />,
});
const Recommendations = Loadable({
  loader: () => import("./components/Mobile/Recommendations"),
  loading: () => <Loading />,
});
/* Delivery */
// import Delivery from "./components/Delivery";
const Delivery = Loadable({
  loader: () => import("./components/Delivery"),
  loading: () => <Loading />,
});

// import DeliveryLogin from "./components/Delivery/Login";
const DeliveryLogin = Loadable({
  loader: () => import("./components/Delivery/Login"),
  loading: () => <Loading />,
});

const DeliveryOtp = Loadable({
  loader: () => import("./components/Delivery/Otp"),
  loading: () => <Loading />,
});

const DeliveryHome = Loadable({
  loader: () => import("./components/Delivery/Home"),
  loading: () => <Loading />,
});

const DeliveryRegister = Loadable({
  loader: () => import("./components/Delivery/Register"),
  loading: () => <Loading />,
});

// import DeliveryOrders from "./components/Delivery/Orders";
const DeliveryOrders = Loadable({
  loader: () => import("./components/Delivery/Orders"),
  loading: () => <Loading />,
});

const DeliveryPersonalDetails = Loadable({
  loader: () => import("./components/Delivery/PersonalDetails"),
  loading: () => <Loading />,
});

const DeliveryBankDetails = Loadable({
  loader: () => import("./components/Delivery/BankDetails"),
  loading: () => <Loading />,
});

const DeliverySettings = Loadable({
  loader: () => import("./components/Delivery/Settings"),
  loading: () => <Loading />,
});

const DeliveryMe = Loadable({
  loader: () => import("./components/Delivery/Me"),
  loading: () => <Loading />,
});

const DeliveryTrySession = Loadable({
  loader: () => import("./components/Delivery/TrySession"),
  loading: () => <Loading />,
});

const DeliveryPolicies = Loadable({
  loader: () => import("./components/Delivery/Policies"),
  loading: () => <Loading />,
});

const DeliveryWelcome = Loadable({
  loader: () => import("./components/Delivery/Welcome"),
  loading: () => <Loading />,
});

const DeliveryKyc = Loadable({
  loader: () => import("./components/Delivery/Kyc"),
  loading: () => <Loading />,
});

const DeliverySelfieCapture = Loadable({
  loader: () => import("./components/Delivery/Kyc/SelfieCapture"),
  loading: () => <Loading />,
});

// import ViewOrder from "./components/Delivery/ViewOrder";
const ViewOrder = Loadable({
  loader: () => import("./components/Delivery/ViewOrder"),
  loading: () => <Loading />,
});

const DeliveryDelivered = Loadable({
  loader: () => import("./components/Delivery/Delivered"),
  loading: () => <Loading />,
});

const DeliveryEarnings = Loadable({
  loader: () => import("./components/Delivery/Earnings"),
  loading: () => <Loading />,
});

const DeliveryWallet = Loadable({
  loader: () => import("./components/Delivery/Wallet"),
  loading: () => <Loading />,
});

const DeliveryHelpdesk = Loadable({
  loader: () => import("./components/Delivery/Helpdesk"),
  loading: () => <Loading />,
});

const DeliveryNotifications = Loadable({
  loader: () => import("./components/Delivery/Notifications"),
  loading: () => <Loading />,
});

const DeliveryConfirmOrder = Loadable({
  loader: () => import("./components/Delivery/ConfirmOrder"),
  loading: () => <Loading />,
});

const DeliveryConfirmOrderCamera = Loadable({
  loader: () => import("./components/Delivery/ConfirmOrderCamera"),
  loading: () => <Loading />,
});

const DeliveryConfirmOrderPhoto = Loadable({
  loader: () => import("./components/Delivery/ConfirmOrderPhoto"),
  loading: () => <Loading />,
});

// import GeoLocationPage from "./components/Mobile/GeoLocationPage";
const GeoLocationPage = Loadable({
  loader: () => import("./components/Mobile/GeoLocationPage"),
  loading: () => <Loading />,
});

const ItemsParent = Loadable({
  loader: () => import("./components/Mobile/Items/ItemsParent"),
  loading: () => null,
});

const StoreFilterPage = Loadable({
  loader: () => import("./components/Mobile/Items/StoreFilterPage"),
  loading: () => null,
});

const SingleItemParent = Loadable({
  loader: () => import("./components/Mobile/Items/SingleItemParent"),
  loading: () => null,
});

const SinglePage = Loadable({
  loader: () => import("./components/SinglePage"),
  loading: () => <Loading />,
});

const ForgotPassword = Loadable({
  loader: () => import("./components/Mobile/Auth/ForgotPassword"),
  loading: () => <Loading />,
});

const RestaurantListOnCategory = Loadable({
  loader: () => import("./components/Mobile/Home/RestaurantListOnCategory"),
  loading: () => <Loading />,
});

const RatingAndReview = Loadable({
  loader: () => import("./components/Mobile/Account/Orders/RatingAndReview"),
  loading: () => <Loading />,
});
const ViewStoreReviews = Loadable({
  loader: () => import("./components/Mobile/StoreReviews"),
  loading: () => <Loading />,
});

const Alerts = Loadable({
  loader: () => import("./components/Mobile/Alerts"),
  loading: () => <Loading />,
});

const FavoriteRestaurantList = Loadable({
  loader: () => import("./components/Mobile/Home/FavoriteRestaurants"),
  loading: () => <Loading />,
});

const FirstScreen = Loadable({
  loader: () => import("./components/Mobile/FirstScreen"),
  loading: () => <Loading />,
});

// Import Phase2 components
const Phase2 = Loadable({
  loader: () => import("./components/Mobile/Phase2"),
  loading: () => <Loading />,
});

const Phase2Category = Loadable({
  loader: () => import("./components/Mobile/Phase2/Category"),
  loading: () => <Loading />,
});

const Phase2Product = Loadable({
  loader: () => import("./components/Mobile/Phase2/Product"),
  loading: () => <Loading />,
});

const Phase2Browse = Loadable({
  loader: () => import("./components/Mobile/Phase2/Browse"),
  loading: () => <Loading />,
});

const Phase2Explore = Loadable({
  loader: () => import("./components/Mobile/Phase2/Explore"),
  loading: () => <Loading />,
});

// Relax brand items page (light theme) — reuses the item-listing layout.
const RelaxBrandItems = Loadable({
  loader: () => import("./components/Mobile/Phase2/Brands/BrandItemsPage"),
  loading: () => <Loading />,
});

// All brands list (See all from Featured Brands)
const RelaxBrandsList = Loadable({
  loader: () => import("./components/Mobile/Phase2/Brands/BrandsListPage"),
  loading: () => <Loading />,
});

// Category browse page (Sprint /categories/stores) product listing — the
// destination when a user taps an L1/L2/L3 tile.
const CategoryItemsPage = Loadable({
  loader: () => import("./components/Mobile/Phase2/Home/Categories/CategoryItemsPage"),
  loading: () => <Loading />,
});

const RelaxSingleItem = Loadable({
  loader: () => import("./components/Mobile/Phase2/Product/RelaxSingleItemParent"),
  loading: () => <Loading />,
});

const LandingPage = Loadable({
  loader: () => import("./components/Mobile/LandingPage/LandingPage"),
  loading: () => <Loading />,
});

const OrderConfirmed = Loadable({
  loader: () => import("./components/Mobile/OrderConfirmed"),
  loading: () => <Loading />,
});

const PaymentDone = Loadable({
  loader: () => import("./components/Mobile/PaymentDone"),
  loading: () => <Loading />,
});

const TrySession = Loadable({
  loader: () => import("./components/Mobile/TrySession"),
  loading: () => <Loading />,
});

const TrySessionPayment = Loadable({
  loader: () => import("./components/Mobile/TrySession/TrySessionPayment"),
  loading: () => <Loading />,
});

// Global runtime error handling for known non-actionable browser warnings
if (typeof window !== 'undefined') {
  const shouldSuppressRuntimeError = (message = "") =>
    message.includes('Cannot redefine property: userAgent') ||
    message.includes('ResizeObserver loop completed with undelivered notifications');

  window.addEventListener('error', function (event) {
    const message =
      (event.error && event.error.message) ||
      event.message ||
      '';
    if (shouldSuppressRuntimeError(message)) {
      console.warn('Caught and suppressed runtime error:', message);
      event.preventDefault();
      return false;
    }
  });

  // Additional protection for unhandled rejections
  window.addEventListener('unhandledrejection', function (event) {
    const message =
      (event.reason && event.reason.message) ||
      (typeof event.reason === 'string' ? event.reason : '') ||
      '';
    if (shouldSuppressRuntimeError(message)) {
      console.warn('Caught and suppressed runtime promise rejection:', message);
      event.preventDefault();
      return false;
    }
  });
}

// Disable browser automatic scroll restoration GLOBALLY (important: outside component)
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Global ScrollToTop component using useLocation
const ScrollToTop = ({ children }) => {
  const { pathname } = require('react-router-dom').useLocation();
  const prevPathnameRef = React.useRef(pathname);

  React.useLayoutEffect(() => {
    // Only scroll to top on NEW route, not on initial mount with same path
    if (prevPathnameRef.current !== pathname) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
    prevPathnameRef.current = pathname;
  }, [pathname]);

  return children || null;
};

const RedirectToStore = ({ match }) => {
  const { productId } = match.params;
  const storePath = `/stores/${productId}`;
  return <Redirect to={storePath} />;
};

const RedirectToItem = ({ match }) => {
  const { productId, id } = match.params;

  // if (id) {
  const itemPath = `/stores/${productId}/${id}`;
  return <Redirect to={itemPath} />;
  // } else {
  //   const storePath = `/stores/${productId}`;
  //   return <Redirect to={storePath} />;
  // }
};

// Helper functions for route identification
const isSingleItemPage = (pathname) => {
  return (
    /^\/stores\/[^/]+\/[^/]+$/.test(pathname) ||
    /^\/product\/[^/]+$/.test(pathname) ||
    /^\/relax\/product\/[^/]+$/.test(pathname) ||
    /^\/phase2\/product\/[^/]+$/.test(pathname)
  );
};

const isStorePage = (pathname) => {
  return /^\/stores\/[^/]+$/.test(pathname);
};

// AnimatedSwitch wrapper for page transitions
// Uses zoom transition for SingleItem page, slide transition for others
const AnimatedSwitch = withRouter(({ location, history, children }) => {
  // Track previous location to determine transitions
  const prevLocationRef = React.useRef(location.pathname);
  // Track previous location state to determine if we came from Compare
  const prevLocationStateRef = React.useRef(location.state);
  // Track the hidden card ID for reveal after transition completes
  const hiddenCardIdRef = React.useRef(null);

  // Update refs after render
  React.useEffect(() => {
    prevLocationRef.current = location.pathname;
    prevLocationStateRef.current = location.state;
  }, [location.pathname, location.state]);

  // Determine page types
  const currentIsSingleItem = isSingleItemPage(location.pathname);
  const prevWasSingleItem = isSingleItemPage(prevLocationRef.current);

  // Default transition settings
  let transitionClass = "fade";
  let transitionTimeout = 300;

  if (prevWasSingleItem && currentIsSingleItem) {
    // Check if navigation from Compare Products should use slide transition
    const useSlideTransition = location.state && location.state.useSlideTransition;

    if (useSlideTransition) {
      // Use slide transition for navigation from Compare Products
      transitionClass = "page";
      transitionTimeout = 300;
    } else if (history.action === 'POP') {
      // Going back from SingleItem to another SingleItem
      // Check if we entered via slide transition (e.g. from Compare Products)
      if (prevLocationStateRef.current && prevLocationStateRef.current.useSlideTransition) {
        transitionClass = "slide-out-right";
        transitionTimeout = 300;
      } else {
        // Default: use slide-out-right for all back navigations (TEMPORARY - was zoom-pop)
        transitionClass = "slide-out-right";
        transitionTimeout = 300;
      }
    } else {
      // Forward navigation: use slide (TEMPORARY - was zoom)
      transitionClass = "page";
      transitionTimeout = 300;
    }
  } else if (currentIsSingleItem) {
    // Check if navigation from Compare Products should use slide transition
    const useSlideTransition = location.state && location.state.useSlideTransition;

    if (useSlideTransition) {
      transitionClass = "page";
      transitionTimeout = 300;
    } else {
      // Entering SingleItem (Push or Pop) - use slide (TEMPORARY - was zoom)
      transitionClass = "page";
      transitionTimeout = 300;
    }
  } else if (history.action === 'POP' && prevWasSingleItem) {
    // RETURNING from SingleItem -> ANY page (Store, Home, etc.)
    // Use slide-out effect (TEMPORARY - was zoom-pop)
    transitionClass = "slide-out-right";
    transitionTimeout = 300;
  } else if (history.action === 'POP') {
    // Returning to any other page (not from SingleItem)
    // Use custom slide-out transition where entering page is static (for scroll restore)
    // and exiting page slides out (fixed overlay)
    transitionClass = "slide-out-right";
    transitionTimeout = 300;
  } else if (history.action === 'PUSH' && location.pathname === '/my-account' &&
    (prevLocationRef.current === '/my-orders' || prevLocationRef.current === '/my-wallet')) {
    // Special case: "Back" button on Orders/Wallet PUSHES to Account.
    // We want this to look like a Back transition (Slide Out).
    transitionClass = "slide-out-right";
    transitionTimeout = 300;
  } else if (history.action === 'PUSH' &&
    location.pathname === '/relax/categories' &&
    /^\/relax\/category\/[^/]+$/.test(prevLocationRef.current)) {
    // SubCategory -> Categories (PUSH via back button)
    transitionClass = "slide-out-right";
    transitionTimeout = 300;
  } else if (history.action === 'PUSH') {
    // Default PUSH transition (Slide in from right)
    transitionClass = "page";
    transitionTimeout = 300;
  }

  // Override: Skip animation if requested (e.g. Footer Sprint/Relay toggle)
  if (location.state && location.state.skipPageTransition) {
    transitionClass = "no-transition";
    transitionTimeout = 0;
  }

  // Manage Global Animation Suppression via CSS Class - SYNCHRONOUSLY during render
  // This ensures the class is present BEFORE children mount
  if (transitionClass === "zoom-pop" || transitionClass === "slide-out-right") {
    document.body.classList.add('is-back-transition');
    document.body.classList.remove('is-opening-transition');
  } else if (transitionClass === "zoom") {
    document.body.classList.add('is-opening-transition');
    document.body.classList.remove('is-back-transition');
  } else {
    document.body.classList.remove('is-back-transition');
    document.body.classList.remove('is-opening-transition');
  }

  // Schedule removal after transition completes (in useEffect for cleanup)
  React.useEffect(() => {
    if (transitionClass === "zoom-pop" || transitionClass === "slide-out-right") {
      const timer = setTimeout(() => {
        document.body.classList.remove('is-back-transition');
      }, transitionTimeout);
      return () => clearTimeout(timer);
    } else if (transitionClass === "zoom") {
      const timer = setTimeout(() => {
        document.body.classList.remove('is-opening-transition');
      }, transitionTimeout);
      return () => clearTimeout(timer);
    }
  }, [transitionClass, transitionTimeout]);


  // Disable browser automatic scroll restoration to handle it manually
  React.useLayoutEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, [history]);

  // Route entry must not depend on the outgoing page's transition/unmount
  // completing. In TWA (or during quick footer navigation), that cleanup can
  // be delayed and leave Home, Orders, or Addresses with a locked document.
  // Account is intentionally a fixed shell with its own internal scroller.
  React.useLayoutEffect(() => {
    if (location.pathname !== '/my-account') {
      releaseDocumentScrollLock();
    }
  }, [location.pathname]);

  // Continuously save scroll position for current route (so it's captured before navigation)
  React.useEffect(() => {
    const saveScrollPosition = () => {
      sessionStorage.setItem(`scrollPos_${location.pathname}`, window.scrollY.toString());
    };

    let scrollTimeout;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(saveScrollPosition, 100);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, [location.pathname]);

  // Update prevLocationRef and handle scroll restoration SYNCHRONOUSLY
  React.useLayoutEffect(() => {
    const prevPath = prevLocationRef.current;
    const currentPath = location.pathname;

    // Determine if we're entering/exiting SingleItem or StorePage
    const isOnSingleItem = isSingleItemPage(currentPath);

    prevLocationRef.current = currentPath;

    // Restore scroll position when coming back via back navigation
    if (history.action === 'POP') {
      const savedPos = sessionStorage.getItem(`scrollPos_${currentPath}`);
      if (savedPos) {
        const scrollVal = parseInt(savedPos, 10);

        // If coming BACK to a non-SingleItem page, restore INSTANTLY
        // This covers Home, StoreList, Explore, etc.
        if (!isOnSingleItem) {
          // Disable smooth scroll temporarily
          const html = document.documentElement;
          html.style.scrollBehavior = 'auto';

          // Force immediate scroll
          window.scrollTo(0, scrollVal);

          // BLINKIT-STYLE: Wait TWO rAF ticks for layout to fully settle
          // Then re-capture coordinates and hide the card
          const prevUrl = prevPath || "";
          const idMatch = prevUrl.match(/\/(\d+)$/);

          if (idMatch && idMatch[1]) {
            const itemId = idMatch[1];
            const cardId = `product-card-${itemId}`;

            // Double rAF to ensure layout is fully computed after scroll
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                try {
                  const card = document.getElementById(cardId);

                  if (card) {
                    const rect = card.getBoundingClientRect();
                    const scaleX = rect.width / window.innerWidth;
                    const scaleY = rect.height / window.innerHeight;

                    // Update CSS variables for the transition
                    html.style.setProperty('--card-top', `${rect.top}px`);
                    html.style.setProperty('--card-left', `${rect.left}px`);
                    html.style.setProperty('--scale-x', `${scaleX}`);
                    html.style.setProperty('--scale-y', `${scaleY}`);

                    // Hide the original card for the ENTIRE animation duration
                    card.classList.add('hidden-transition-card');

                    // Store the card ID so onExited can reveal it
                    hiddenCardIdRef.current = cardId;
                  }
                } catch (e) {
                  console.warn("Transition Coords Calc Error", e);
                }
              });
            });
          }

          // Re-enable smooth scroll after paint
          requestAnimationFrame(() => {
            html.style.scrollBehavior = '';
          });
        } else {
          // SingleItem might handle its own scroll, or use default
          window.scrollTo(0, scrollVal);
        }
      }
    }
  }, [location.pathname, history.action]);

  // TWA can skip transitionend; settle leftover fixed wrappers after timeout.
  // Never pick the exiting Categories/Home wrapper as "active" — that freezes
  // document scroll on the incoming page.
  React.useEffect(() => {
    const delay = Math.max(transitionTimeout, 0) + 80;
    const timer = setTimeout(() => {
      settleEnteredWrapper(null);
    }, delay);
    const fallback = setTimeout(() => {
      settleEnteredWrapper(null);
    }, Math.max(delay, 450));
    return () => {
      clearTimeout(timer);
      clearTimeout(fallback);
    };
  }, [location.pathname, transitionTimeout]);

  const handleTransitionComplete = () => {
    releaseDocumentScrollLock();

    if (history.action === 'PUSH') {
      // Check if we just entered SingleItem page
      const isEnteringSingleItem = isSingleItemPage(location.pathname);
      const isEnteringStorePage = isStorePage(location.pathname);
      const wasStorePage = isStorePage(prevLocationRef.current); // Use ref for previous

      // DON'T scroll to top if:
      // 1. We are coming FROM SingleItem (we want to keep/restore parent scroll)
      // For SingleItem entry, let the fixed overlay handle its own scroll

      if (!prevWasSingleItem) {
        // Keep scroll intact when deep-linking to a specific order on My Orders.
        const focusingOrder =
          location.pathname === "/my-orders" &&
          typeof location.search === "string" &&
          /(?:^|[?&])order=/.test(location.search);

        if (!focusingOrder) {
          // Disable smooth scroll temporarily to prevent visual jumping/scrolling
          const html = document.documentElement;
          html.style.scrollBehavior = "auto";

          window.scrollTo(0, 0);

          // Re-enable smooth scroll
          requestAnimationFrame(() => {
            html.style.scrollBehavior = "";
          });
        }
      }
    }
  };

  return (
    <TransitionGroup
      childFactory={child => React.cloneElement(child, {
        classNames: transitionClass,
        timeout: transitionTimeout
      })}
    >
      <AnimatedRoutePage
        key={location.pathname}
        classNames={transitionClass}
        timeout={transitionTimeout}
        onEntered={handleTransitionComplete}
        onExited={() => {
          // Reveal the hidden card AFTER animation completes
          if (hiddenCardIdRef.current) {
            const card = document.getElementById(hiddenCardIdRef.current);
            if (card) {
              // Wait one rAF before revealing to ensure overlay is still on top
              requestAnimationFrame(() => {
                card.classList.remove('hidden-transition-card');
                hiddenCardIdRef.current = null;
              });
            } else {
              hiddenCardIdRef.current = null;
            }
          }
        }}
      >
        <Switch location={location}>{children}</Switch>
      </AnimatedRoutePage>
    </TransitionGroup>
  );
});

/**
 * Owns nodeRef so CSSTransition avoids deprecated findDOMNode.
 * MUST forward TransitionGroup props (`in`, `onExited`, appear/enter/exit, etc.)
 * or exits never complete and a leftover fixed wrapper blocks all clicks.
 */
function AnimatedRoutePage({
  classNames,
  timeout,
  onEntered,
  onExited,
  children,
  ...transitionProps
}) {
  const nodeRef = React.useRef(null);

  const handleEntered = (...args) => {
    settleEnteredWrapper(nodeRef.current);
    if (onEntered) onEntered(...args);
  };

  const handleExited = (...args) => {
    if (onExited) onExited(...args);
  };

  return (
    <CSSTransition
      {...transitionProps}
      nodeRef={nodeRef}
      classNames={classNames}
      timeout={timeout}
      onEntered={handleEntered}
      onExited={handleExited}
    >
      <div className="page-transition-wrapper" ref={nodeRef}>
        {children}
      </div>
    </CSSTransition>
  );
}

// Pre-define tracked components to prevent remounts
const TrackedApp = withTracker(App);
const TrackedLandingPage = withTracker(LandingPage);
const TrackedPhase2Category = withTracker(Phase2Category);
const TrackedPhase2Product = withTracker(Phase2Product);
const TrackedPhase2Browse = withTracker(Phase2Browse);
const TrackedPhase2Explore = withTracker(Phase2Explore);
const TrackedRelaxBrandItems = withTracker(RelaxBrandItems);
const TrackedRelaxBrandsList = withTracker(RelaxBrandsList);
const TrackedCategoryItemsPage = withTracker(CategoryItemsPage);
const TrackedRelaxSingleItem = withTracker(RelaxSingleItem);
const TrackedLocation = withTracker(Location);
const TrackedGeoLocationPage = withTracker(GeoLocationPage);
const TrackedRestaurantListOnCategory = withTracker(RestaurantListOnCategory);
const TrackedItemsParent = withTracker(ItemsParent);
const TrackedStoreFilterPage = withTracker(StoreFilterPage);
const TrackedSingleItemParent = withTracker(SingleItemParent);
const TrackedBestSellingItems = withTracker(BestSellingItems);
const TrackedRecommendations = withTracker(Recommendations);
const TrackedContentScreen = withTracker(ContentScreen);
const TrackedForgotPassword = withTracker(ForgotPassword);
const TrackedRegister = withTracker(Register);
const TrackedAccount = withTracker(Account);
const TrackedEditProfilePage = withTracker(EditProfilePage);
const TrackedCustomerSupportPage = withTracker(CustomerSupportPage);
const TrackedAlerts = withTracker(Alerts);
const TrackedAddresses = withTracker(Addresses);
const TrackedWalletPage = withTracker(WalletPage);
const TrackedOrders = withTracker(Orders);
const TrackedRatingAndReview = withTracker(RatingAndReview);
const TrackedViewStoreReviews = withTracker(ViewStoreReviews);
const TrackedCheckout = withTracker(Checkout);
const TrackedRunningOrder = withTracker(RunningOrder);
const TrackedCartPage = withTracker(CartPage);
const TrackedSinglePage = withTracker(SinglePage);
const TrackedFavoriteRestaurantList = withTracker(FavoriteRestaurantList);
const TrackedCouponList = withTracker(CouponList);
const TrackedFirstScreen = withTracker(FirstScreen);
const TrackedOrderConfirmed = withTracker(OrderConfirmed);
const TrackedTrySession = withTracker(TrySession);
const TrackedTrySessionPayment = withTracker(TrySessionPayment);

// Capacitor's native shell has no server-side rewrite (unlike the Hostinger
// .htaccess which maps /delivery -> delivery.html). When the delivery iOS/Android
// app boots via server.appStartPath: "delivery.html", the URL bar path is
// "/delivery.html", which doesn't match any React Router route below. Rewrite it
// to "/delivery" before the first render so DeliveryLogin (not NotFound) shows up.
if (Capacitor.isNativePlatform()) {
  const nativeStartPath = window.location.pathname;
  if (nativeStartPath === "/delivery.html" || nativeStartPath === "/delivery.html/") {
    window.history.replaceState(null, "", "/delivery" + window.location.search + window.location.hash);
  }
}

// Google sign-in pop-up (used when the site runs inside a frame): pass the answer to the opener and close.
relayGooglePopupResultIfNeeded();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Root>
    <BrowserRouter>
      <React.Fragment>
        <ThemeColorController />
        <NativeBackButton />
        {/* ScrollToTop moved to onEntered callback in AnimatedSwitch */}
        <PersistentFooterContext.Provider value={true}>
        <AnimatedSwitch>
          <Route path={"/"} exact component={TrackedApp} />
          <Route path={"/relax"} exact component={TrackedApp} />
          {/* Legacy /phase2 → /relax redirects (preserve old links/bookmarks) */}
          <Redirect exact from={"/phase2"} to={"/relax"} />
          <Redirect exact from={"/phase2/categories"} to={"/relax/categories"} />
          <Redirect exact from={"/phase2/category/:slug"} to={"/relax/category/:slug"} />
          <Redirect
            exact
            from={"/phase2/products/:categorySlug/:subcategorySlug"}
            to={"/relax/products/:categorySlug/:subcategorySlug"}
          />
          <Redirect exact from={"/phase2/product/:slug"} to={"/relax/product/:slug"} />
          <Redirect exact from={"/phase2/browse/:tag"} to={"/relax/browse/:tag"} />
          <Redirect exact from={"/phase2/explore"} to={"/relax/explore"} />
          <Redirect exact from={"/phase2/brands"} to={"/relax/brands"} />
          <Redirect exact from={"/phase2/brand/:id"} to={"/relax/brand/:id"} />
          <Route path={"/splashscreen"} exact component={TrackedFirstScreen} />
          <Route path={"/firstscreen"} exact>
            <Redirect to="/splashscreen" />
          </Route>

          <Route path={"/landing"} exact component={TrackedLandingPage} />

          {/* Relax Sub-Routes (light theme; same components as Rush) */}
          <Route path={"/relax/categories"} exact component={TrackedPhase2Category} />
          <Route path={"/relax/category/:slug"} exact component={TrackedPhase2Category} />
          <Route path={"/relax/products/:categorySlug/:subcategorySlug"} exact component={TrackedPhase2Product} />
          <Route path={"/relax/product/:slug"} exact component={TrackedRelaxSingleItem} />
          <Route path={"/relax/browse/:tag"} exact component={TrackedPhase2Browse} />
          <Route path={"/relax/explore"} exact component={TrackedPhase2Explore} />
          {/* All brands (See all) — must be before /relax/brand/:id */}
          <Route path={"/relax/brands"} exact component={TrackedRelaxBrandsList} />
          {/* Relax brand items page (all products of a brand, globally) */}
          <Route path={"/relax/brand/:id"} exact component={TrackedRelaxBrandItems} />
          <Route
            path={"/relax/my-account"}
            exact
            render={() => <Redirect to="/my-account" />}
          />

          <Route
            path={"/search-location"}
            exact
            component={TrackedLocation}
          />
          <Route
            path={"/my-location"}
            exact
            component={TrackedGeoLocationPage}
          />

          <Route
            path={"/categories/stores"}
            exact
            component={TrackedPhase2Category}
          />

          <Route
            path={"/categories/items"}
            exact
            component={TrackedCategoryItemsPage}
          />

          <Route
            path={"/public/product/:productId"}
            exact
            component={RedirectToStore}
          />

          <Route
            path={"/public/product/:productId/:id"}
            exact
            component={RedirectToItem}
          />

          {/* <RedirectHandler /> */}

          <Route
            path={"/stores/:restaurant"}
            exact
            component={TrackedItemsParent}
          />

          <Route
            path={"/stores/:restaurant/filters"}
            exact
            component={TrackedStoreFilterPage}
          />

          <Route
            path={"/stores/:restaurant/:id"}
            exact
            component={TrackedSingleItemParent}
          />

          <Route
            path={"/best-selling-items"}
            exact
            component={TrackedBestSellingItems}
          />

          <Route
            path={"/recommendations"}
            exact
            component={TrackedRecommendations}
          />

          <Route path={"/explore"} exact component={TrackedPhase2Explore} />

          <Route
            path={"/content-screen"}
            exact
            component={TrackedContentScreen}
          />

          <Route path={"/login"} exact component={TrackedFirstScreen} />
          <Route
            path={"/otp"}
            exact
            render={(routeProps) => (
              <TrackedFirstScreen {...routeProps} otpOnly />
            )}
          />
          <Route
            path={"/login/forgot-password"}
            exact
            component={TrackedForgotPassword}
          />
          <Route path={"/register"} exact component={TrackedRegister} />

          <Route
            path={"/my-account/customer-support"}
            exact
            render={() => <Redirect to="/my-account/custmer-support" />}
          />
          <Route
            path={"/my-account/custmer-support"}
            exact
            component={TrackedCustomerSupportPage}
          />
          <Route path={"/my-account/edit-profile"} exact component={TrackedEditProfilePage} />
          <Route path={"/my-account"} exact component={TrackedAccount} />
          <Route path={"/alerts"} exact component={TrackedAlerts} />
          <Route
            path={"/my-addresses"}
            exact
            component={TrackedAddresses}
          />
          <Route
            path={"/my-wallet"}
            exact
            component={TrackedWalletPage}
          />
          <Route path={"/my-orders"} exact component={TrackedOrders} />
          <Route
            path={"/rate-order/:id"}
            exact
            component={TrackedRatingAndReview}
          />
          <Route
            path={"/reviews/:slug"}
            exact
            component={TrackedViewStoreReviews}
          />

          <Route path={"/checkout"} exact component={TrackedCheckout} />
          <Route
            path={"/order-confirmed/:unique_order_id"}
            exact
            component={TrackedOrderConfirmed}
          />
          <Route
            path={"/payment-done/:unique_order_id"}
            exact
            component={PaymentDone}
          />
          <Route
            path={"/running-order/:unique_order_id"}
            exact
            component={TrackedRunningOrder}
          />
          <Route
            path={"/try-session/:unique_order_id"}
            exact
            component={TrackedTrySession}
          />
          <Route
            path={"/try-session/:unique_order_id/summary"}
            render={({ match }) => (
              <Redirect to={`/payment-done/${match.params.unique_order_id}`} />
            )}
          />
          <Route
            path={"/try-session/:unique_order_id/complete"}
            render={({ match }) => (
              <Redirect to={`/payment-done/${match.params.unique_order_id}`} />
            )}
          />
          <Route
            path={"/try-session-payment/:unique_order_id"}
            exact
            component={TrackedTrySessionPayment}
          />

          <Route path={"/cart"} exact component={TrackedCartPage} />

          <Route
            path={"/pages/:slug"}
            exact
            component={TrackedSinglePage}
          />
          <Route
            path={"/my-favorite-stores"}
            exact
            render={() => <Redirect to="/my-wishlist?tab=stores" />}
          />
          <Route
            path={"/my-wishlist"}
            exact
            component={TrackedFavoriteRestaurantList}
          />
          <Route
            path={"/coupon-list"}
            exact
            component={TrackedCouponList}
          />
          <Route path={"/delivery"} exact component={DeliveryLogin} />
          <Route path={"/delivery/login"} exact component={DeliveryLogin} />
          <Route path={"/delivery/otp"} exact component={DeliveryOtp} />
          <Route path={"/delivery/register"} exact component={DeliveryRegister} />
          <Route path={"/delivery/home"} exact component={DeliveryHome} />
          <Route path={"/delivery/orders"} exact component={DeliveryOrders} />
          <Route
            path={"/delivery/personal-details"}
            exact
            component={DeliveryPersonalDetails}
          />
          <Route
            path={"/delivery/bank-details"}
            exact
            component={DeliveryBankDetails}
          />
          <Route
            path={"/delivery/settings"}
            exact
            component={DeliverySettings}
          />
          <Route path={"/delivery/profile"} exact component={DeliveryMe} />
          <Route
            path={"/delivery/me"}
            exact
            render={() => <Redirect to="/delivery/profile" />}
          />
          <Route path={"/delivery/try-session"} exact component={DeliveryTrySession} />
          <Route
            path={"/delivery/policies/:slug?"}
            exact
            component={DeliveryPolicies}
          />
          <Route path={"/delivery/welcome"} exact component={DeliveryWelcome} />
          <Route path={"/delivery/kyc"} exact component={DeliveryKyc} />
          <Route
            path={"/delivery/kyc/selfie"}
            exact
            component={DeliverySelfieCapture}
          />
          <Route
            path={"/delivery/orders/:unique_order_id"}
            exact
            component={ViewOrder}
          />
          <Route
            path={"/delivery/delivered/:unique_order_id?"}
            exact
            component={DeliveryDelivered}
          />
          <Route
            path={"/delivery/payment-done/:unique_order_id?"}
            exact
            component={DeliveryDelivered}
          />
          <Route
            path={"/delivery/earnings"}
            exact
            component={DeliveryEarnings}
          />
          <Route
            path={"/delivery/wallet"}
            exact
            component={DeliveryWallet}
          />
          <Route
            path={"/delivery/helpdesk"}
            exact
            component={DeliveryHelpdesk}
          />
          <Route
            path={"/delivery/notifications"}
            exact
            component={DeliveryNotifications}
          />
          {/* Pickup proofs are captured inline on the Orders card now. */}
          <Route
            path={"/delivery/confirm-order/pickup/:unique_order_id?"}
            exact
            render={() => <Redirect to="/delivery/orders" />}
          />
          <Route
            path={"/delivery/confirm-order/:stage/:unique_order_id?"}
            exact
            component={DeliveryConfirmOrder}
          />
          <Route
            path={"/delivery/confirm-order/:unique_order_id"}
            exact
            render={(props) => (
              <Redirect to={`/delivery/confirm-order/handover/${props.match.params.unique_order_id}`} />
            )}
          />
          <Route
            path={"/delivery/confirm-order/capture/:photo_side/:unique_order_id?"}
            exact
            component={DeliveryConfirmOrderCamera}
          />
          <Route
            path={"/delivery/confirm-order/photo/:photo_side/:unique_order_id?"}
            exact
            component={DeliveryConfirmOrderPhoto}
          />
          <Route path={"/delivery/map"} exact component={ViewOrder} />
          <Route
            path={"/delivery/completed-orders"}
            exact
            component={Delivery}
          />
          {/* Common Routes */}
          <Route component={NotFound} />
          {/* <Route path={"/shared"} component={ShareItemAndStore} /> */}
        </AnimatedSwitch>
        </PersistentFooterContext.Provider>
        <PersistentAppNav />
      </React.Fragment>
    </BrowserRouter>
  </Root>
);

// Register the service worker for PWA support and push notifications (web only).
// In development, drop stale /service-worker.js workers that return HTML (MIME error).
if (!Capacitor.isNativePlatform()) {
  if (process.env.NODE_ENV === "production") {
    serviceWorkerRegistration.register();
  } else if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => {
        const scriptURL =
          (reg.active && reg.active.scriptURL) ||
          (reg.waiting && reg.waiting.scriptURL) ||
          (reg.installing && reg.installing.scriptURL) ||
          "";
        if (scriptURL.includes("/service-worker.js")) {
          reg.unregister().catch(() => {});
        }
      });
    });
  }
}
